module.exports = __webpack_public_path__ + "static/media/tools.b475ca01.png";